import React, { ReactElement, useCallback } from "react";

import { useEffectOnce } from "@swiggy-private/core-ui";

import { FoodItemTypeOfferBundlesProps } from "../interfaces";

import ExtraCartItemInlineButton from "../components/ExtraCartItemInlineButton";
import { ItemPrice } from "../components/ItemPrice";

import { getButtonTitle, getPlanForNudgeAnalytics } from "@cart-ui/helpers/OfferBundle";

export const FoodItemTypeOfferBundles = React.memo(function FoodItemTypeOfferBundles({
    children,
    updating,
    item,
    onUpdateItem,
    analyticsEvents,
    onePlanType,
}: FoodItemTypeOfferBundlesProps): ReactElement | null {
    useEffectOnce(() => {
        analyticsEvents.impressionCartInline(getPlanForNudgeAnalytics(item, "", onePlanType));
    });

    const onUpdateItemClick = useCallback(() => {
        analyticsEvents.clickCartInline(getPlanForNudgeAnalytics(item), getButtonTitle(item));
        onUpdateItem(item);
    }, [onUpdateItem, item, analyticsEvents]);

    if (!item) return null;

    return (
        <>
            {children}
            <ExtraCartItemInlineButton onClick={onUpdateItemClick} updating={updating} title={getButtonTitle(item)} />
            <ItemPrice
                itemPrice={item?.plan_details.base_price || 0}
                finalPrice={item?.plan_details.final_price || 0}
                freeQuantity={0}
            />
        </>
    );
});
